"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SpacesMediumDsEmbedded_1 = require("../../gen-src/icons/SpacesMediumDsEmbedded");
var Localize_1 = require("../../gen-src/Localize");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
var DataQualityWarningEmbeddedDatasources_1 = require("../components/DataQualityWarnings/DataQualityWarningEmbeddedDatasources");
var DatabaseIcon_1 = require("../components/icons/DatabaseIcon");
var SiteUrlsContext_1 = require("../urls/SiteUrlsContext");
var PublishedDatasourceIcon_1 = require("../components/icons/PublishedDatasourceIcon");
var ViewerPaneLayoutComponents_1 = require("./ViewerPaneLayoutComponents");
/** A widget to display a single datasource */
var VizClientDatasourceElement = /** @class */ (function (_super) {
    __extends(VizClientDatasourceElement, _super);
    function VizClientDatasourceElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VizClientDatasourceElement.prototype.render = function () {
        var _this = this;
        return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
            return React.createElement(ViewerPaneStyles_1.DatasourceListBodyElement, null,
                React.createElement(ViewerPaneStyles_1.DatasourceIconNameContainer, null,
                    React.createElement(ViewerPaneLayoutComponents_1.MultiLineLinkWithIcon, { linkText: _this.props.datasource.name, linkHref: urls.workbookDatasourcesUrl(_this.props.workbookVizportalUrlId), iconComponent: React.createElement(DatasourceIconElement, { datasource: _this.props.datasource }), iconPosition: 'top', iconSize: 'medium' })),
                React.createElement(DatasourceConnections, { datasource: _this.props.datasource }),
                // Only display the database connections if the embedded datasource is connected to
                // a local file/table (i.e., not to a published datasource)
                !_this.props.datasource.hasPublishedDatasource
                    && React.createElement(DatasourceDatabasesConnections, { connections: _this.props.datasource.databasesConnectionNodes }),
                React.createElement(DatasourceQualityWarnings, { datasource: _this.props.datasource }));
        }));
    };
    return VizClientDatasourceElement;
}(React.PureComponent));
exports.VizClientDatasourceElement = VizClientDatasourceElement;
function DatasourceIconElement(props) {
    return props.datasource.__typename === 'EmbeddedDatasource'
        ? React.createElement(SpacesMediumDsEmbedded_1.SvgSpacesMediumDsEmbedded, null)
        : null; // No icon for published data sources
}
function DatasourceConnections(props) {
    if (!props.datasource.hasPublishedDatasource) {
        return null;
    }
    return (React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.Table, { valueCellFlexGrow: 2 },
        React.createElement(PublishedDatasourceConnectionIconNameRow, { datasource: props.datasource.publishedDatasource }),
        React.createElement(PublishedDatasourceExtractLiveRow, { datasource: props.datasource.publishedDatasource })));
}
function DatasourceDatabasesConnections(props) {
    if (!props.connections) {
        return null;
    }
    return (React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.Table, { valueCellFlexGrow: 2 }, props.connections.map(function (connection) {
        return React.createElement(React.Fragment, { key: connection.id },
            React.createElement(EmbeddedDatasourceConnectionIconNameRow, { connection: connection }),
            React.createElement(EmbeddedDatasourceExtractLiveRow, { connection: connection }));
    })));
}
function EmbeddedDatasourceConnectionIconNameRow(props) {
    var isObfuscated = props.connection === null || props.connection.name === null;
    return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.Row, null,
            React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.LabelCell, { style: ViewerPaneLayoutComponents_1.getPaddingTopStyleForTextWithIcon({ iconSize: 'medium' }) }, Localize_1.Messages.DatasourceConnectionLabel()),
            React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.ValueCell, null, isObfuscated ? ViewerPaneLayoutComponents_1.ViewerPaneObfuscatedPlaceholder() :
                React.createElement(ViewerPaneLayoutComponents_1.MultiLineLinkWithIcon, { iconComponent: props.connection ? DatabaseIcon_1.DatabaseMediumIcon({
                        database: {
                            __typename: props.connection.__typename,
                            connectionType: props.connection.connectionType,
                            isCertified: props.connection.isCertified || false,
                        }
                    }) : React.createElement("div", null), iconSize: 'medium', iconPosition: 'top', linkText: props.connection && props.connection.name || '', linkHref: props.connection && urls.catalogDatabaseUrl(props.connection.id) || '' })));
    }));
}
function EmbeddedDatasourceExtractLiveRow(props) {
    var isObfuscated = props.connection === null || props.connection.name === null;
    if (isObfuscated) {
        return null;
    }
    // An embedded datasource will, by definition, have a live connection.
    return (React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.Row, null,
        React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.LabelCell, null, Localize_1.Messages.DatasourceExtractLiveLabel()),
        React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.ValueCell, null, Localize_1.Messages.DatasourceLiveValue())));
}
function PublishedDatasourceConnectionIconNameRow(props) {
    var isObfuscated = props.datasource === null || props.datasource.name === null;
    return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.Row, null,
            React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.LabelCell, { style: ViewerPaneLayoutComponents_1.getPaddingTopStyleForTextWithIcon({ iconSize: 'medium' }) }, Localize_1.Messages.DatasourceConnectionLabel()),
            React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.ValueCell, null, isObfuscated ? ViewerPaneLayoutComponents_1.ViewerPaneObfuscatedPlaceholder() :
                React.createElement(ViewerPaneLayoutComponents_1.MultiLineLinkWithIcon, { iconComponent: props.datasource &&
                        PublishedDatasourceIcon_1.PublishedDatasourceIcon({ hasExtracts: !!props.datasource.hasExtracts, isCertified: props.datasource.isCertified }), iconSize: 'medium', iconPosition: 'top', iconTitle: props.datasource &&
                        PublishedDatasourceIcon_1.PublishedDatasourceIconTooltip({ hasExtracts: !!props.datasource.hasExtracts, isCertified: props.datasource.isCertified }), linkText: props.datasource && props.datasource.name || '', linkHref: urls.datasourceLineageFieldsUrl(props.datasource && props.datasource.vizportalUrlId || '') })));
    }));
}
function PublishedDatasourceExtractLiveRow(props) {
    var isObfuscated = props.datasource === null || props.datasource.name === null;
    if (isObfuscated || props.datasource === null || props.datasource.hasExtracts === undefined) {
        return null;
    }
    return (React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.Row, null,
        React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.LabelCell, null, Localize_1.Messages.DatasourceExtractLiveLabel()),
        React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.ValueCell, null, props.datasource.hasExtracts
            ? (props.datasource.extractLastUpdateTime
                ? Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(props.datasource.extractLastUpdateTime))
                : Localize_1.Messages.DatasourceExtractValue())
            : Localize_1.Messages.DatasourceLiveValue())));
}
function DatasourceQualityWarnings(props) {
    // Leave an empty label so that, if there is no DQW widget, the row displays with minimal space used.
    return (React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.Row, null,
        React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.LabelCell, null),
        React.createElement(ViewerPaneLayoutComponents_1.MetadataTable.ValueCell, null,
            React.createElement(DataQualityWarningEmbeddedDatasources_1.EmbeddedDatasourceDataQualityWarning, { nodeId: props.datasource.id }))));
}
//# sourceMappingURL=VizClientDatasourceElement.js.map